<script>
    export let settings;
    export let userdata;

    let tmp = userdata;
    tmp = settings;

    import { loaded_components } from '../store.js';

    $loaded_components = [...$loaded_components, 'basket'];
</script>

<div id="basket"></div>

<style lang="scss">

</style>
